import { type VirtualScrollNodesProvider } from '@blaze-runtime/engine-ui-feature';

export class TableRowsProvider implements VirtualScrollNodesProvider {
  getDOMNodes(rootElement: ChildNode): HTMLElement[] {
    const elements: HTMLElement[] = [];
    this.traverse(rootElement, elements);
    return elements;
  }

  getIndexOfElement(element: HTMLElement): number {
    const rowIndex = element.getAttribute('aria-rowindex');

    if (!rowIndex) {
      return -1;
    }

    // aria-rowindex starts from 1 and the strategy expects indexes starting from 0
    return +rowIndex - 1;
  }

  getSize(element: HTMLElement): number {
    return element.clientHeight;
  }

  private traverse(node: ChildNode, elements: HTMLElement[]): void {
    if (node instanceof HTMLElement && node.classList.contains('row')) {
      elements.push(node);
    }
    if (node.childNodes.length > 0) {
      node.childNodes.forEach((childNode) => {
        this.traverse(childNode, elements);
      });
    }
  }
}
